export const QualitysoftwareData = [
    {
        Lable: "Solution for Quality of software application.",
        Description: "DynamicEMR ensures top- notch quality through a combination of rigorous testing, continuous monitoring, and user - centric design.Extensive QA protocols, including unit tests, integration tests, and user acceptance testing.i.e User Feedback, Performance Optimization etc."
    }
]